module.exports = __webpack_public_path__ + "img/Spinner.795ce1be.gif";